import { mergeOverrideValues, turnParamsIntoUrl } from '../utils/convertObject';
import { getFeatureToggle } from '../utils/featureTogglesUtils';

var getClient = function getClient() {
  var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  if (win.ruiAdClient) {
    return win.ruiAdClient;
  }

  if (getFeatureToggle('sasStaging')) {
    return 'reasfdc';
  }

  return 'rea';
};

var getServerUrlPart = function getServerUrlPart(type) {
  return type === 'lazyjs' ? '/jserver' : '/hserver';
};

var getUniqueParamUrlPart = function getUniqueParamUrlPart(adSpot, blackList) {
  mergeOverrideValues(adSpot.config, adSpot.sasOverrides);
  var params = mergeOverrideValues(adSpot.getUniqueParams(), adSpot.sasOverrides);
  var urlParams = turnParamsIntoUrl(params, blackList);
  var url = "".concat(urlParams, "/size=").concat(adSpot.config.sz);

  if (adSpot.config.version) {
    url += "/version=".concat(adSpot.config.version);
  }

  return url;
};

var getPageParamUrlPart = function getPageParamUrlPart(adSpot, blackList) {
  var config = mergeOverrideValues(adSpot.config, adSpot.sasOverrides);
  var params = mergeOverrideValues(adSpot.getPageParams(), adSpot.sasOverrides);
  var siteComponents = config.site.split('.');
  var siteAbbreviation = siteComponents[0];
  var channel = params.areaprefix || params.channel || siteComponents[1];
  var pageType = params.sect;
  var urlParams = turnParamsIntoUrl(params, blackList);
  var url = "/site=".concat(siteAbbreviation, "/area=").concat(channel, ".").concat(pageType).concat(urlParams, "/random=").concat(adSpot.random);
  return url;
};

var getViewIdUrlPart = function getViewIdUrlPart(viewId) {
  return "/viewid=".concat(viewId);
};

var getAdType = function getAdType(type) {
  return type === 'native' ? '/adtype=safeframe' : '';
};

export default {
  getClient: getClient,
  getServerUrlPart: getServerUrlPart,
  getUniqueParamUrlPart: getUniqueParamUrlPart,
  getPageParamUrlPart: getPageParamUrlPart,
  getViewIdUrlPart: getViewIdUrlPart,
  getAdType: getAdType
};
//# sourceMappingURL=providerUtil.js.map